import { Box, Chip } from "@mui/material";
import { useTranslate } from "@tolgee/react";

export type TeamsCellTeam = {
  id: string;
  name: string;
  isActive: boolean;
};

export function TeamsCell({ teams }: { teams: TeamsCellTeam[] }) {
  const { t } = useTranslate("Global");

  if (teams.length === 0) return null;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {teams.map(team => (
        <Box
          key={team.id}
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        >
          <Chip size="small" label={team.name} />
          {!team.isActive && (
            <Chip
              size="small"
              label={t("Deactivated")}
              color="default"
              variant="outlined"
            />
          )}
        </Box>
      ))}
    </Box>
  );
}
